import handleMethod from '../Utils/APIutils/handleMethod';

class EventAPI {
  async getById(id) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/${id}`,
    });
  }

  async list({
    page = 1,
    itemsPerPage = 20,
    deviceId,
    clientId,
    storeId,
    search,
    severityLevel,
    isResolved,
    startDate,
    endDate,
    sortBy = 'createdAt',
    sortDirection = 'desc',
  } = {}) {
    const params = new URLSearchParams();

    params.set('page', page);
    params.set('itemsPerPage', itemsPerPage);

    if (deviceId) params.set('deviceId', deviceId);
    if (clientId) params.set('clientId', clientId);
    if (storeId) params.set('storeId', storeId);
    if (search) params.set('search', search);
    if (severityLevel) params.set('severity', severityLevel);

    if (typeof isResolved === 'boolean') {
      params.set('isResolved', String(isResolved));
    }

    if (startDate) {
      params.set('startDate', new Date(startDate).toISOString());
    }

    if (endDate) {
      params.set('endDate', new Date(endDate).toISOString());
    }

    if (sortBy) params.set('sortBy', sortBy);
    if (sortDirection) params.set('sortDirection', sortDirection);

    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events?${params.toString()}`,
    });
  }

  async getRecentByDevice(deviceId, lastHours = 24) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/device/${deviceId}/recent?lastHours=${lastHours}`,
    });
  }

  async getByDateRange(deviceId, startDate, endDate) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();

    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/device/${deviceId}/range?startDate=${from}&endDate=${to}`,
    });
  }

  async getByType(eventType) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/by-type?eventType=${eventType}`,
    });
  }

  async getByDeviceAndType(deviceId, eventType) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/device/${deviceId}/by-type?eventType=${eventType}`,
    });
  }

  async getByClient(clientId, limit = 100) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/by-client/${clientId}?limit=${limit}`,
    });
  }

  async getErrors(lastHours = 24) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/errors?lastHours=${lastHours}`,
    });
  }

  async resolve(id) {
    return handleMethod({
      type: 'PUT',
      method: `api/gatewaycontagem/events/${id}/resolve`,
    });
  }

  async saveComment(id, comments) {
    return handleMethod({
      type: 'PUT',
      method: `api/gatewaycontagem/events/${id}/comment`,
      params: { comments },
    });
  }

  async resolveAll({ clientId, deviceId } = {}) {
    return handleMethod({
      type: 'POST',
      method: `api/gatewaycontagem/events/resolve-all`,
      params: { clientId, deviceId },
    });
  }

  async getStats({ clientId, deviceId, startDate, endDate, storeId } = {}) {
    const params = new URLSearchParams();
    if (clientId) params.set('clientId', clientId);
    if (deviceId) params.set('deviceId', deviceId);
    if (storeId) params.set('storeId', storeId);
    if (startDate) params.set('startDate', new Date(startDate).toISOString());
    if (endDate) params.set('endDate', new Date(endDate).toISOString());

    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/stats?${params.toString()}`,
    });
  }

  async getCriticalCount(clientId) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/events/critical-count?clientId=${clientId}`,
    });
  }

  async cleanup(retentionDays) {
    const params = new URLSearchParams();
    if (typeof retentionDays === 'number') params.set('retentionDays', retentionDays);
    const qs = params.toString() ? `?${params.toString()}` : '';
    return handleMethod({
      type: 'POST',
      method: `api/gatewaycontagem/events/cleanup${qs}`,
    });
  }
}

export const eventAPI = new EventAPI();
